import { type TrackingContextValue, widgetView } from '@ps/web-core-analytics';

import { GAEvent } from './utils';

export const widgetViewed = (context: TrackingContextValue, name: string) => {
  // CRM zones track their own views
  if (!context.widget?.widgetName.startsWith('Crm')) {
    GAEvent({ action: 'Widget Viewed', label: name }, context);
    widgetView({}, context);
  }
};
